const th = {

    search:"ค้นหา",


    organization:"องค์กร",
    year:"ปี",
    months:"เดือน",
    days:"วัน",
    assessment:"ประเมิน",
    assessments:"แบบประเมินตนเอง",
    self:"ตนเอง",
    subordinate:"ผู้ใต้บังคับบัญชา",

    staffID:"รหัส พนักงาน",
    department:"หน่วยงาน",
    status:"สถานะ",
    process:"กระบวนการ",

    fullname:" ชื่อ-นามสกุล",
    position:"ตำแหน่ง",
    remark:"หมายเหตุ ",
    startDate:"วันที่เริ่มงาน",
    yearsOfService:"อายุงาน",
    staffTypes:"ประเภทบุคลากร",
    competencyLevel:"ระดับ",

    reportStatus:"สถานะการตอบแบบประเมินรายหน่วยงาน",
    reportCc:"สรุปผลประเมินแยกราย Core Competency",
    reportCompetency:"สรุปผลประเมินแยกรายหน่วยงาน",


    save:"บันทึก",
    send:"ส่งข้อมูล",
    unsend:"ยกเลิกการส่ง",
    reject:"ตีกลับข้อมูล",
    remove:"ลบข้อมูล",

    LatestTime:"เวลาล่าสุด",

    idp: {
        title:"แบบฟอร์มแผนพัฒนาบุคลากรรายบุคคล",
        round:"รอบการประเมิน พ.ศ.",

        section1 : "ส่วนที่ 1 : ข้อมูลส่วนบุคคล ",
        nameSurname : "ชื่อ-นามสกุล",
        position : "ตำแหน่ง",
        department : "หน่วยงานที่สังกัด",
        yearsofService : "อายุงาน",
        supervisor : "ผู้บังคับบัญชาชั้นต้น",
        instructions : "คำชี้แจง",


        section2 :"ส่วนที่ 2 : แผนพัฒนาบุคลากรรายบุคคล (ทำร่วมกับผู้บังคับบัญชาชั้นต้น)",
        note : ["1. ให้ผู้รับการพัฒนาระบุ  (1)  วิธีการพัฒนาและรายละเอียดที่เกี่ยวข้องตามหัวข้อที่กำหนดให้ (2) ระบุสิ่งที่ได้เรียนรู้จากการพัฒนาหลังการพัฒนาเสร็จสิ้น","2. ให้ผู้บังคับบัญชาชั้นต้นติดตามพฤติกรรม หรือผลลัพธ์ที่ได้หลังจากเข้ารับการพัฒนาตามแผนพัฒนารายบุคคลและประเมินผลการพัฒนาในระบบส่วนที่ 3"],

        yourself:"ตนเอง",
        subordinate:"ผู้ใต้บังคับบัญชา",

        method:"วิธีการพัฒนา",
        course:"หลักสูตร",
        details:"รายละเอียด",
        period:"ระยะเวลา",
        budget: "งบประมาณ",
        learnedDeveloper:"สิ่งที่ได้เรียนรู้จากการพัฒนา",
        learned:"สิ่งที่ได้เรียนรู้",
        suggestions:"ข้อเสนอแนะ",
        verification : "การตรวจสอบ",
        results : "การประเมินผลลัพธ์",

        dialog: {
            clear : "ท่านยืนยันที่จะลบข้อมูลที่ได้บันทึกไว้ก่อนหน้านี้",
            verification : "⚠️ เนื่องจากมีวิธีการพัฒนาที่ท่านไม่เห็นชอบ ยืนยันการส่งผลหรือไม่ ",
        }

    },

    idpReprot:{
        reportIDPCompetency:"สรุปผลประเมินแยกรายสมรรถนะ",
        reportIDPStatus:"สถานะการประเมินแยกรายบุคคล",
    },

    tooltip: {
        assessment:"เปลี่ยนผู้ประเมิน",
        detail:"รายละเอียด"
    },

    faculty: "สำนักวิชา",

    agree:"เห็นชอบ",
    disagree:"ไม่เห็นชอบ",

    gap:{
        found:"Gap Found",
        notFound:"No Gap",
    },

    orders : "ลำดับ",


    parameter: {
        invalid : "ข้อมูลไม่ครบ หรือข้อมูลผิดพลาด"
    },

    reports:{
        member : "Member",
    }


}
export default th
